import { formatRut } from '@/app/shared/utils/rut.utils';
import { toTitleCase } from '@/app/shared/utils/string.utils';
import { ProviderProfile } from '../models/provider-profile.model';
import { ProviderProfileApiData } from './provider-profile-api.types';

const titleCaseOrNull = (value: string | null): string | null =>
  value?.trim() ? toTitleCase(value.trim()) : null;

export function toProviderProfile(data: ProviderProfileApiData): ProviderProfile {
  return {
    legalName: titleCaseOrNull(data.businessName),
    rut: data.rut ? formatRut(data.rut) : null,
    email: data.email,
    phone: data.phone,
    address: titleCaseOrNull(data.address),
    commune: titleCaseOrNull(data.commune),
    mainSpecialty: data.mainSpecialty,
  };
}
